<template>
  <div class="topbar">
    <div class="wrap">
      <div><span>欢迎访问云南供应链协会官方网站</span></div>
      <div><span>联系电话：{{ siteConfig.phone }}</span></div>
    </div>
  </div>
  <header class="site-header">
    <div class="wrap">
      <a class="logo" @click="goHome">
        <div class="logo-mark">YSCA</div>
        <div><b>云南供应链协会</b><small>Yunnan Supply Chain Association</small></div>
      </a>
      <nav class="nav">
        <a
            v-for="(item, index) in navItems"
            :key="index"
            :class="{ active: currentPath === item.path }"
            @click="handleFunctionClick(item)"
        >
          {{ item.title }}
        </a>
      </nav>
      <div class="menu-toggle" @click="toggleMenu">
        <div class="menu-line" v-for="n in 3" :key="n"></div>
      </div>
    </div>
  </header>
  <div v-if="menuOpen" class="mobile-menu-container">
    <a
        v-for="(item, index) in navItems"
        :key="index"
        @click="handleFunctionClick(item)"
        class="hamburger-nav-item"
        :class="{ active: currentPath === item.path }"
    >
      {{ item.title }}
    </a>
  </div>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue';
import { siteConfig } from '@/composables/useSiteConfig.js';
import { useRoute, useRouter } from 'vue-router';

defineProps({
  isTransparent: {
    type: Boolean,
    default: true,
  },
  topPlaceholderRemove: {
    type: Boolean,
    default: false,
  },
});

// 定义导航项数据
const navItems = ref([
  {
    title: "首页",
    path: "/",
  },
  {
    title: "会员风采",
    path: "/membership-list",
  },
  {
    title: "企业展示",
    path: "/firm-list",
  },
  {
    title: "产品展示",
    path: "/product-list",
  },
  {
    title: "协会活动",
    path: "/association-activity",
  },
]);

// 获取当前路由路径
const route = useRoute();
const currentPath = computed(() => route.path);

const menuOpen = ref(false);

const router = useRouter();
const handleFunctionClick = (item) => {
  //判断url是否是http或https
  if (item.path.indexOf('http://') !== -1 || item.path.indexOf('https://') !== -1) {//是
    window.open(item.path, '_blank')
  } else {//否
    router.push(item.path);
  }
};

const goHome = () => {
  router.push('/');
};

function toggleMenu() {
  menuOpen.value = !menuOpen.value;
}
</script>

<style scoped>
.menu-toggle {
  display: none; /* 默认隐藏 */
  flex-direction: column;
  cursor: pointer;
}

.menu-line {
  height: 3px;
  width: 25px;
  background-color: var(--color-primary-900);
  margin: 3px 0;
}

.mobile-menu-container {
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 110px;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, .98);
  border-bottom: 1px solid var(--line);
  box-shadow: var(--shadow-md);
  z-index: 999;
  padding: 10px 0;
}

.hamburger-nav-item {
  width: 100%;
  text-align: center;
  font-size: 16px;
  color: var(--text-2);
  padding: 12px 0;
  cursor: pointer;
}

.hamburger-nav-item.active {
  color: var(--color-primary-500);
  font-weight: 600;
}

/* 移动端样式 */
@media (max-width: 960px) {
  .menu-toggle {
    display: flex;
  }

  .site-header .wrap {
    height: 56px;
  }

  .logo-mark {
    width: 38px;
    height: 38px;
    font-size: 13px;
  }

  .logo b {
    font-size: 16px;
  }

  .logo small {
    display: none;
  }

  .mobile-menu-container {
    top: 90px;
  }
}
</style>
